import { observable } from "mobx";
import React from "react";
import {montarSelectOption} from "../../../utils/formatar";
import moment from "moment";

export default class FiltrosServicoStore {

    @observable clientes;
    @observable grupos;
    @observable subgrupos;
    @observable status;

    @observable clienteSelecionado;
    @observable grupoSelecionado;
    @observable subgrupoSelecionado;
    @observable statusSelecionado;

    @observable filtros;

    constructor(service) {
        this.clienteSelecionado = false;
        this.grupoSelecionado = false;
        this.subgrupoSelecionado = false;
        this.statusSelecionado = false;
        this.filtros = {
            dataInicial: moment().subtract(15, 'day').format("YYYY-MM-DD"),
            dataFinal: moment().add(0, 'day').format("YYYY-MM-DD"),
            container: ""
        };

        this.service = service;

        this.carregarFiltros();
    };

    carregarFiltros = () => {
        this.service.listarClientes().then(response => {
            if (response.data) {
                this.clientes = montarSelectOption("ParcId", "RazSocial", response.data);
            }
        });

        this.service.listarGrupos().then(response => {
            if (response.data) {
                this.grupos = montarSelectOption("Id", "DscGrupo", response.data);
            }
        });

        this.service.listarStatus().then(response => {
            if (response.data) {
                this.status = montarSelectOption("Codigo", "Descr", response.data);
            }
        });
    };

    onChangeFiltro = (dado, event) => {
        if (event) {
            _.set(this.filtros, dado, event.target.value);
        } else {
            _.set(this.filtros, dado, null);
        }
    };

    onChangeCliente = value => {
        this.clienteSelecionado = value!==null ? value : false;
    };

    onChangeGrupo = value => {
        this.subgrupoSelecionado = false;
        if (value!==null) {
            this.grupoSelecionado = value;
            this.service.listarSubgrupos(value.value).then(response => {
                if (response.data) {
                    this.subgrupos = montarSelectOption("AgendTipoServId", "DscTipoServ", response.data);
                }
            });
        } else {
            this.grupoSelecionado = false;
        }
    };

    onChangeSubgrupo = value => {
        this.subgrupoSelecionado = value!==null ? value : false;
    };

    onChangeStatus = value => {
        this.statusSelecionado = value!==null ? value : false;
    };

    onChangeDataInicio = (data) => {
        this.filtros.dataInicial = data;
    };

    onChangeDataFim = (data) => {
        this.filtros.dataFinal = data;
    };
}



// WEBPACK FOOTER //
// ./src/modules/acompanhamentoservico/stores/FiltrosAcompServicoStore.js